import { createStyles, makeStyles } from '@material-ui/core/styles';
import { INFO_GREEN, YELLOW, DARK_GRAY } from 'constants/colors';
export default makeStyles(theme => {
  return createStyles({
    box: {
      padding: theme.spacing(1)
    },
    infoBox: {
      backgroundColor: INFO_GREEN
    },
    warningBox: {
      marginTop: theme.spacing(1),
      backgroundColor: YELLOW,
      color: DARK_GRAY
    }
  });
});